const DAILY_MENU_STORAGE_VERSION = "v1";
const DAILY_MENU_STORAGE_PREFIX = "aile-cooking-daily";

export function getLocalDateKey(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getDailyMenuStorageKey(familyId, lang = "tr") {
  const safeFamilyId = encodeURIComponent(String(familyId || "anonymous"));
  const safeLang = lang === "en" ? "en" : "tr";
  return `${DAILY_MENU_STORAGE_PREFIX}:${DAILY_MENU_STORAGE_VERSION}:${safeFamilyId}:${safeLang}`;
}

function resolveStorage(storage) {
  if (storage) return storage;
  if (typeof window === "undefined") return null;

  try {
    return window.localStorage;
  } catch (_) {
    return null;
  }
}

export function readDailyMenuId({ familyId, lang = "tr", date = new Date(), storage } = {}) {
  const targetStorage = resolveStorage(storage);
  if (!targetStorage || !familyId) return null;

  try {
    const rawValue = targetStorage.getItem(getDailyMenuStorageKey(familyId, lang));
    if (!rawValue) return null;

    const saved = JSON.parse(rawValue);
    if (saved?.dateKey !== getLocalDateKey(date)) return null;

    const menuId = Number(saved?.menuId);
    return Number.isFinite(menuId) ? menuId : null;
  } catch (_) {
    return null;
  }
}

export function writeDailyMenuId({ familyId, lang = "tr", menuId, date = new Date(), storage } = {}) {
  const targetStorage = resolveStorage(storage);
  const normalizedMenuId = Number(menuId);
  if (!targetStorage || !familyId || !Number.isFinite(normalizedMenuId)) return false;

  try {
    targetStorage.setItem(
      getDailyMenuStorageKey(familyId, lang),
      JSON.stringify({
        dateKey: getLocalDateKey(date),
        menuId: normalizedMenuId,
      }),
    );
    return true;
  } catch (_) {
    return false;
  }
}
